class ProductGalleryProgressBar {
  constructor(el) {
    this.el = el;
    this.thumb = el.querySelector('.product-gallery-progress-bar__thumb');
    this.count = parseInt(el.dataset.count, 10) || 1;
    this.gallery = el.closest('media-gallery');

    this.update(0);

    if (this.gallery) {
      this.gallery.addEventListener('slideshow:select', (event) => {
        this.update(event.detail.index);
      });
    }
  }

  update(index) {
    const percent = 100 / this.count;
    this.thumb.style.width = `${percent}%`;
    this.thumb.style.transform = `translate3d(${index * 100}%, 0, 0)`;
  }
}

document.querySelectorAll('.product-gallery-progress-bar').forEach((el) => {
  new ProductGalleryProgressBar(el);
});
